import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OmnisearchProvider } from "@src/appV2/Omnisearch";
import { type Agent } from "@src/appV2/User/api/useSearchAgents";
import { type Facility } from "@src/appV2/User/api/useSearchFacilities";
import { pseudo } from "@src/modules/session";
import { useRecentlyVisited } from "@src/appV2/lib/utils/useRecentlyVisited";
import { logEvent } from "@src/appV2/lib/analytics";
import { ADMIN_EVENTS } from "@src/constants/firebaseEvents";

export function ConnectedOmnisearch() {
  const dispatch = useDispatch();
  const session = useSelector((state: { session: { admin: boolean } }) => state.session);
  const isAdmin = session?.admin;
  const [, addToRecent] = useRecentlyVisited();

  const handleSelectAgent = useCallback(
    (agent: Agent) => {
      dispatch(pseudo({ userId: agent.userId }, false));
      addToRecent({ id: agent.userId, title: agent.name, type: "AGENT" });
      logEvent(ADMIN_EVENTS.SELECT_HCP, { id: agent.userId });
    },
    [dispatch, addToRecent]
  );

  const handleSelectFacility = useCallback(
    (facility: Facility) => {
      dispatch(pseudo({ userId: facility.userId }, false));
      addToRecent({ id: facility.userId, title: facility.name, type: "FACILITY" });
      logEvent(ADMIN_EVENTS.SELECT_HCF, { id: facility.userId });
    },
    [dispatch, addToRecent]
  );

  if (!isAdmin) {
    return null;
  }

  return (
    <OmnisearchProvider onSelectAgent={handleSelectAgent} onSelectFacility={handleSelectFacility}>
      <></>
    </OmnisearchProvider>
  );
}
